<template>
  <div>
    <CRow>
      <CCol sm="12">
          <CCard>
              <CCardHeader>
                  <Strong>Existing Payment Methods</Strong>
              </CCardHeader>
              <CCardBody>
<CRow>
      <CCol sm="12">
        <CTableWrapper
          :items="paymentInfo"
          hover
          striped
          bordered
          small
          fixed
          caption="Child Accounts"
        />
      </CCol>
    </CRow>
              </CCardBody>
          </CCard>

        <CCard>
          <CCardHeader>
            <strong>Add new ACH Payment Information </strong> 
            
          </CCardHeader>
          <CCardBody>
              <CRow>
                  <CCol sm="12">
                      <strong>How To Read your account information from an cheque</strong><br/>
<p>
                      Transit Number: This number is five digits and corresponds to the home branch where you initially opened your account. Even if you perform your banking at another branch due to convenience or in the event you move, this number will not change unless you open a new account.
</p>
<p>
Institution Code: This is three digits providing additional info to the transit number and is the code for a Canadian bank or financial institution. If a bank has one branch or 500, it is the same three-digit code. For example, the Bank of Montreal Institution code is always 001, TD Bank is always 004 and so on.
</p>
<p>
Account Number: This portion an vary from seven to twelve digits in length. The length and format of this number are bank specific. Some banks use dashes; others do not.
</p>
                      </ccol>
                      <CCol sm="12">
                  <img src="/img/example_cheque.jpg" />
                  </ccol>
              </CRow>
            <CRow>
              <CCol sm="12">
                <CInput
                  label="Financial Institution Name"
                  placeholder="Financial Institution Name"
                  v-model="financialInstitutionName"
                />
              </CCol>
            </CRow>
                        <CRow>
              <CCol sm="12">
                <CInput
                  label="Branch Address"
                  placeholder="123 Main Street, Anytown, ON, H0H0H0"
                  v-model="branchAddress"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="4">
                <CInput
                  label="Institution Number (3 Digits)"
                  placeholder="000"
                  v-model="financialInstitutionNumber"
                 
                />
              </CCol>
              <CCol sm="4">
                <CInput
                  label="Transit Number (5 Digits)"
                  placeholder="00000"
                  v-model="transitNumber"
                 
                />
              </CCol>

            <CCol sm="4">
                <CInput
                  label="Account Number"
                  placeholder="0000000"
                  v-model="accountNumber"
                 
                />
              </CCol>


            </CRow>
<CRow>
                  <CCol col="6" class="text-left">
                    <CButton color="primary" @click="handleSubmit" class="px-4">Submit</CButton>
                  </CCol>
                 
                </CRow>
          </CCardBody>
        </CCard>
      </CCol>
      </Crow>
      
    </div>
</template>

<script>
import CTableWrapper from './PaymentInfoTable.vue'
export default {
    
  name: 'PaymentInfo',
  components: { CTableWrapper },
  data () {
    return {
        financialInstitutionName: "",
        financialInstitutionNumber: "",
        accountNumber: "",
        transitNumber: "",
        branchAddress: "",
        paymentInfo: [],
      selected: [], // Must be an array reference!
      show: true,
      horizontal: { label:'col-3', input:'col-9' },
      options: ['Option 1', 'Option 2', 'Option 3'],
      selectOptions: [
        'Option 1', 'Option 2', 'Option 3',
        { 
          value: ['some value', 'another value'], 
          label: 'Selected option'
        }
      ],
      selectedOption: ['some value', 'another value'],

      formCollapsed: true,
      checkboxNames: ['Checkboxes', 'Inline Checkboxes',
                      'Checkboxes - custom', 'Inline Checkboxes - custom'],
      radioNames: ['Radios', 'Inline Radios',
                    'Radios - custom', 'Inline Radios - custom']
    }
  },
  mounted: function () {
      this.loadPaymentInfo();
    },
    methods: {
        loadPaymentInfo: function () {
        var self = this;
       this.$http
        .get(this.$apiUrl + "/v1/account/paymentinfo", {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("session_id")
          }
        })
        .then(function (response) {
          console.log(JSON.stringify(response))
          self.paymentInfo = response.data;
        })
        .catch(function (error) {
            this.$snotify.error('There was an unexpected error loading your information - please contact EGATE Support', 'Error!');
          console.log(error)
        })
        
      },
      handleSubmit(e){
                e.preventDefault()
                var self = this;
                var router = router;
                // TODO - preflight validation
                const options = {
  headers: {'X-Custom-Header': 'value'}
};
                    this.$http.post(this.$apiUrl + '/v1/account/createach', {
                        
                        institutionNumber: this.financialInstitutionNumber,
                        accountNumber: this.accountNumber,
                        transitNumber: this.transitNumber,
                        branchAddress: this.branchAddress

                    }, 
                    {
                        headers: {
                            Authorization: "Bearer " + localStorage.getItem("session_id")
                        },
                    })
                    .then(response => {
                        if (response.status != 200) {
                            this.$snotify.error('There was an unexpected error storing your information - please contact EGATE Support', 'Error!');
                        } else {
                            this.$snotify.success('ACH Info Stored');
                            this.loadPaymentInfo();
                        }
                    })
                    .catch(function (error) {
                        self.loginError = true;
                        this.$snotify.error('There was an unexpected error storing your information - please contact EGATE Support', 'Error!');
                        console.error(error.response);
                    });
                
            }
    
  }
}
</script>
